import { FeedbackBar } from "./FeedbackBar";
import { HumanEvaluator } from "@/types/app/evaluator";
import { DEFAULT_FEEDBACK_TYPES } from "@/lib/feedback";
import { EvaluatorLog, Log } from "@/types/app/log";

interface Props {
  evaluators: HumanEvaluator[];
  datapoint: Log;
  onAddFeedback: (evaluatorLog: EvaluatorLog) => void;
}

const DrawerFeedbackSection = ({ evaluators, datapoint, onAddFeedback }: Props) => {
  const ratingEvaluator = evaluators?.find((evaluator) => evaluator?.name === "rating");
  const actionEvaluator = evaluators?.find((evaluator) => evaluator?.name === "action");
  const issueEvaluator = evaluators?.find((evaluator) => evaluator?.name === "issue");
  const commentEvaluator = evaluators?.find((evaluator) => evaluator?.name === "comment");
  const correctionEvaluator = evaluators?.find((evaluator) => evaluator?.name === "correction");

  return (
    <div className="flex flex-col gap-y-16">
      {/* Correction  - TODO: always show */}
      {correctionEvaluator && (
        <FeedbackBar evaluator={correctionEvaluator} log={datapoint} onAddFeedback={onAddFeedback} />
      )}

      {/* Rating */}
      {ratingEvaluator && <FeedbackBar evaluator={ratingEvaluator} log={datapoint} onAddFeedback={onAddFeedback} />}

      {/* Action */}
      {actionEvaluator &&
        "options" in actionEvaluator.spec &&
        actionEvaluator.spec.options &&
        actionEvaluator.spec.options.length > 0 && (
          <FeedbackBar evaluator={actionEvaluator} log={datapoint} onAddFeedback={onAddFeedback} />
        )}

      {/* Issue */}
      {issueEvaluator &&
        "options" in issueEvaluator.spec &&
        issueEvaluator.spec.options &&
        issueEvaluator.spec.options.length > 0 && (
          <FeedbackBar evaluator={issueEvaluator} log={datapoint} onAddFeedback={onAddFeedback} />
        )}

      {/* Comment */}
      {commentEvaluator && <FeedbackBar evaluator={commentEvaluator} log={datapoint} onAddFeedback={onAddFeedback} />}

      {/* Others */}

      {evaluators
        // Filter out the special cased CRAIC outputs (corrections, ratings, actions, issues, comments)
        .filter((evaluator) => !(DEFAULT_FEEDBACK_TYPES as string[]).includes(evaluator.name))
        // Filter out categorical feedback types (its an array) with no labels (its empty)
        // undefined is ok, null is ok, but empty array is not
        .filter((evaluator) => {
          const options = "options" in evaluator.spec && evaluator.spec.options;
          if (!options) return true;
          return options.length !== 0;
        })
        // sort order: classification, generation
        .sort((evaluator1, evaluator2) => evaluator1.spec.return_type.localeCompare(evaluator2.spec.return_type) || 0)
        .map((evaluator) => (
          <FeedbackBar key={evaluator.id} evaluator={evaluator} log={datapoint} onAddFeedback={onAddFeedback} />
        ))}
    </div>
  );
};

export default DrawerFeedbackSection;
